export const NoEligibleTeamMessage={
    title:'No eligible teams',
    message:'This school does not have an eligible team to participate in this event.'
}

export const WrongGenderTeamMessage={
    title:'Incorrect team selection',
    message:'Your participant list contain wrong gender teams for this event'
}


// WEBPACK FOOTER //
// ./src/utils/warningmessages.js